import SettingsMetaData from "../../../../Components/Hooks/useSettingsMetaData";


const PriorityTask = () => {
  return (
    <SettingsMetaData propertyName={"Priority_Task"} viewPropertyName={"Priority"} />
  );
};
export default PriorityTask;